const fr = {
  app: {
    name: 'Indabo za Mariya',
    tagline: 'Gestion Paroissiale',
    subtitle: 'Système de Gestion Paroissiale',
  },
  common: {
    search: 'Rechercher',
    filter: 'Filtrer',
    all: 'Tous',
    actions: 'Actions',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    deactivate: 'Désactiver',
    activate: 'Activer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    create: 'Créer',
    confirm: 'Confirmer',
    close: 'Fermer',
    export: 'Exporter',
    download: 'Télécharger',
    yes: 'Oui',
    no: 'Non',
    optional: 'optionnel',
    required: 'requis',
    loading: 'Chargement...',
    saving: 'Enregistrement...',
    deleting: 'Suppression...',
    submit: 'Soumettre',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    none: 'Aucun',
    select_placeholder: 'Sélectionner...',
    no_results: 'Aucun résultat',
    no_data: 'Aucune donnée à afficher',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    open_menu: 'Ouvrir le menu',
    close_menu: 'Fermer le menu',
    language: 'Langue',
    page_of: 'Page {current} sur {total}',
    showing_results: '{from}–{to} sur {total} résultats',
    name: 'Nom',
    full_name: 'Nom complet',
    phone: 'Téléphone',
    email: 'Email',
    role: 'Rôle',
    notes: 'Notes',
    date: 'Date',
    status: 'Statut',
    type: 'Type',
    amount: 'Montant',
    reference: 'Référence',
    method: 'Méthode',
    event: 'Événement',
    total: 'Total',
    currency_rwf: 'RWF',
    refresh: 'Actualiser',
    api_required: 'Cette page utilise les données du serveur. Définissez REACT_APP_API_URL pour l’activer.',
    server_secret_hint: 'Ces intégrations sont configurées comme secrets du serveur (variables d’environnement) — elles ne peuvent pas être modifiées depuis cet écran.',
  },
  nav: {
    section_main: 'Principal',
    section_management: 'Gestion',
    section_analysis: 'Analyse',
    section_admin: 'Administration',
    dashboard: 'Tableau de Bord',
    members: 'Membres',
    events: 'Pèlerinages',
    payments: 'Paiements',
    reports: 'Rapports',
    users: 'Utilisateurs',
    roles: 'Rôles & Permissions',
    audit: 'Journal d’audit',
    profile: 'Mon profil',
    logout: 'Déconnexion',
    reservations: 'Réservations',
    transport: 'Transport',
    finance: 'Finances',
    payouts: 'Retraits',
    documents: 'Procès-verbaux & rapports',
    settings: 'Paramètres',
  },
  pages: {
    finance: { title: 'Finances', subtitle: 'Registre des recettes et dépenses' },
    dashboard: { title: 'Tableau de Bord', subtitle: 'Vue d’ensemble générale' },
    members: { title: 'Membres', subtitle: 'Gestion des fidèles inscrits' },
    events: { title: 'Pèlerinages', subtitle: 'Événements & inscriptions' },
    payments: { title: 'Finances', subtitle: 'Cotisations & offrandes' },
    reports: { title: 'Rapports', subtitle: 'Export PDF & Excel' },
    users: { title: 'Utilisateurs & Rôles', subtitle: 'Gestion des accès' },
    not_found: { title: 'Page introuvable', subtitle: 'La page demandée n’existe pas.' },
    forbidden: { title: 'Accès refusé', subtitle: 'Vous n’avez pas la permission d’accéder à cette page.' },
    roles: { title: 'Rôles & Permissions', subtitle: 'Définition des accès par rôle' },
    audit: { title: 'Journal d’audit', subtitle: 'Historique complet des actions utilisateurs' },
    profile: { title: 'Mon profil', subtitle: 'Compte personnel et sécurité' },
    reservations: { title: 'Réservations', subtitle: 'Réservations du site & paiements en ligne' },
    transport: { title: 'Transport', subtitle: 'Bus, points de départ & affectations' },
    payouts: { title: 'Retraits', subtitle: 'Fonds collectés & virements sortants' },
    documents: { title: 'Procès-verbaux & rapports', subtitle: 'Procès-verbaux, rapports & annonces' },
    settings: { title: 'Paramètres', subtitle: 'Intégrations, frais & numéro de retrait' },
  },
  auth: {
    login_title: 'Connexion',
    username: 'Nom d’utilisateur',
    password: 'Mot de passe',
    username_placeholder: 'Entrez votre nom d’utilisateur',
    password_placeholder: 'Entrez votre mot de passe',
    sign_in: 'Se Connecter',
    signing_in: 'Connexion...',
    fill_credentials: 'Veuillez remplir les identifiants',
    invalid_credentials: 'Identifiants invalides',
    verse: '"Je suis le chemin, la vérité et la vie." — Jean 14:6',
    logged_in: 'Bienvenue, {name}',
    logged_out: 'Vous avez été déconnecté',
  },
  dashboard: {
    total_members: 'Total Membres',
    active_members: 'Membres Actifs',
    pilgrims_registered: 'Pèlerins Inscrits',
    total_revenue: 'Revenus Totaux',
    this_month_added: '↑ {count} ce mois',
    percent_of_total: '{percent}% du total',
    this_week_added: '↑ {count} cette semaine',
    revenue_year: 'RWF — cette année',
    monthly_revenue: 'Revenus Mensuels',
    monthly_revenue_sub: 'Cotisations, pèlerinages & offrandes',
    recent_payments: 'Derniers Paiements',
    upcoming_events: 'Prochains Pèlerinages',
    recent_activity: 'Activité Récente',
    spots_left: 'places',
    booked: 'réservés',
    quick_actions: 'Actions Rapides',
    record_payment: 'Enregistrer Paiement',
    new_member: 'Nouveau Membre',
    new_event: 'Nouvel Événement',
    generate_report: 'Générer Rapport',
  },
  members: {
    title: 'Registre des Membres',
    subtitle: '{count} fidèles inscrits',
    new_member: 'Nouveau Membre',
    edit_member: 'Modifier le Membre',
    view_member: 'Détails du Membre',
    delete_confirm_title: 'Supprimer ce membre ?',
    delete_confirm_body: 'Cette action est irréversible. Le membre {name} sera supprimé du registre.',
    search_placeholder: 'Rechercher par nom, ID, téléphone, paroisse...',
    filter_status: 'Tous les statuts',
    field_first_name: 'Prénom',
    field_last_name: 'Nom',
    field_phone: 'Téléphone',
    field_email: 'Email',
    field_address: 'Adresse',
    field_joined_at: 'Date d’inscription',
    field_status: 'Statut',
    field_notes: 'Notes',
    field_total_paid: 'Total Versé',
    field_id: 'ID',
    statuses: {
      active: 'Actif',
      inactive: 'Inactif',
      pending: 'En attente',
    },
    toast_created: 'Membre {name} ajouté',
    toast_updated: 'Membre {name} mis à jour',
    toast_deleted: 'Membre supprimé',
    empty_title: 'Aucun membre trouvé',
    empty_body: 'Ajoutez un premier membre pour démarrer le registre.',
    field_parish: 'Paroisse',
    field_gender: 'Sexe',
    field_marital_status: 'État civil',
    field_national_id: 'N° d’identité / passeport',
    field_date_of_birth: 'Date de naissance',
    national_id_hint: 'Optionnel — carte d’identité à 16 chiffres ou n° de passeport (6 à 20 lettres/chiffres)',
    national_id_invalid: 'Utilisez 6 à 20 lettres ou chiffres',
    dob_in_past: 'La date de naissance doit être dans le passé',
    not_specified: 'Non précisé',
    genders: {
      male: 'Homme',
      female: 'Femme',
    },
    marital_statuses: {
      single: 'Célibataire',
      married: 'Marié(e)',
      widowed: 'Veuf / veuve',
      divorced: 'Divorcé(e)',
      religious: 'Religieux / religieuse',
    },
  },
  events: {
    title: 'Pèlerinages et Événements',
    subtitle: 'Gestion des voyages spirituels',
    new_event: 'Nouvel Événement',
    edit_event: 'Modifier l’Événement',
    view_event: 'Détails de l’Événement',
    delete_confirm_title: 'Supprimer cet événement ?',
    delete_confirm_body: 'Cette action est irréversible. L’événement {name} sera supprimé.',
    search_placeholder: 'Rechercher des événements...',
    filter_status: 'Tous les statuts',
    field_name: 'Nom de l’événement',
    field_destination: 'Destination',
    field_date: 'Date',
    field_capacity: 'Capacité',
    field_registered: 'Inscrits',
    field_price: 'Prix Ticket',
    field_status: 'Statut',
    field_description: 'Description',
    field_reference: 'Référence',
    registered_count: '{count} ({percent}%)',
    statuses: {
      open: 'Ouvert',
      closed: 'Fermé',
      completed: 'Terminé',
      cancelled: 'Annulé',
    },
    toast_created: 'Événement {name} créé',
    toast_updated: 'Événement {name} mis à jour',
    toast_deleted: 'Événement supprimé',
    monthly_badge: 'Mensuel · dernier dimanche',
    no_limit: 'Sans limite',
    capacity_hint: 'Facultatif — vide ou 0 = sans limite',
    field_booking: 'Réservations',
    booking_open: 'Réservations ouvertes',
    booking_reopened: 'Rouvertes',
    booking_closed: 'Réservations fermées',
    booking_closes: 'Ferme le {when}',
    booking_until: 'Ouvert jusqu’au {when}',
    action_reopen_booking: 'Rouvrir les réservations',
    action_close_booking: 'Fermer les réservations',
    toast_booking_reopened: 'Réservations rouvertes pour {name}',
    toast_booking_closed: 'Réservations refermées pour {name}',
    empty_title: 'Aucun événement',
    empty_body: 'Créez votre premier pèlerinage pour commencer.',
  },
  payments: {
    title: 'Transactions Financières',
    subtitle: 'Historique complet des paiements',
    new_payment: 'Enregistrer Paiement',
    record_payment: 'Enregistrer',
    short_label: 'Paiement',
    edit_payment: 'Modifier le Paiement',
    view_payment: 'Détails du Paiement',
    delete_confirm_title: 'Supprimer ce paiement ?',
    delete_confirm_body: 'Cette action est irréversible. Le paiement {ref} sera supprimé.',
    search_placeholder: 'Rechercher par membre, référence...',
    filter_type: 'Tous types',
    filter_status: 'Tous statuts',
    total_collected: 'Total Collecté',
    pending: 'En Attente',
    this_month: 'Ce Mois-ci',
    field_member: 'Membre',
    field_payer: 'Membre ou payeur',
    payer_hint: 'Sélectionnez un membre ou tapez un nom',
    payer_guest_action: 'Enregistrer pour « {name} » (non-membre)',
    payer_guest_label: 'Non-membre',
    payer_required: 'Sélectionnez un membre ou saisissez un nom',
    payer_search_empty: 'Aucun membre trouvé',
    field_type: 'Type',
    field_amount: 'Montant',
    field_date: 'Date',
    field_method: 'Méthode',
    field_event: 'Événement',
    field_status: 'Statut',
    field_notes: 'Notes',
    total_all_time: 'RWF — Toute période',
    pending_caption: 'Paiements à confirmer',
    this_month_caption: 'RWF — Mois en cours',
    types: {
      cotisation: 'Cotisation',
      pelerinage: 'Pèlerinage',
      offrande: 'Offrande',
    },
    methods: {
      mobile_money: 'Mobile Money',
      bank_transfer: 'Virement Bancaire',
      cash: 'Espèces',
      card: 'Carte Bancaire',
    },
    statuses: {
      paid: 'Payé',
      pending: 'En attente',
      cancelled: 'Annulé',
      refunded: 'Remboursé',
    },
    toast_created: 'Paiement {ref} enregistré',
    toast_updated: 'Paiement {ref} mis à jour',
    toast_deleted: 'Paiement supprimé',
    toast_marked_paid: 'Paiement {ref} confirmé',
    mark_as_paid: 'Confirmer comme payé',
    empty_title: 'Aucun paiement',
    empty_body: 'Enregistrez un premier paiement pour démarrer.',
    field_external_ref: 'Référence passerelle',
  },
  reports: {
    section_title: 'Rapports et Exportations',
    section_subtitle: 'Générez et téléchargez des rapports en PDF ou Excel',
    cards: {
      members_title: 'Rapport des Membres',
      members_text: 'Total, actifs, inactifs et historique des cotisations',
      events_title: 'Rapport Pèlerinages',
      events_text: 'Pèlerins par événement, revenus, places disponibles',
      finance_title: 'Bilan Financier',
      finance_text: 'Revenus par type, résumé mensuel, historique complet',
      monthly_title: 'Rapport Mensuel',
      monthly_text: 'Détail financier complet pour un mois sélectionné',
      member_history_title: 'Historique par Membre',
      member_history_text: 'Tous les paiements enregistrés pour un fidèle',
      official_title: 'Rapport Officiel',
      official_text: 'Rapport formaté pour soumission aux autorités',
    },
    generate_title: 'Générer le rapport',
    select_period: 'Période',
    period_all: 'Toute la période',
    period_year: 'Cette année',
    period_month: 'Ce mois',
    format_pdf: 'PDF',
    format_excel: 'Excel',
    toast_generated: 'Rapport {name} prêt — téléchargement démarré',
  },
  users: {
    title: 'Utilisateurs du Système',
    subtitle: 'Gestion des rôles et permissions',
    new_user: 'Ajouter Utilisateur',
    edit_user: 'Modifier l’Utilisateur',
    deactivate_confirm_title: 'Désactiver cet utilisateur ?',
    deactivate_confirm_body: 'L’utilisateur {name} ne pourra plus se connecter.',
    activate_confirm_title: 'Réactiver cet utilisateur ?',
    activate_confirm_body: 'L’utilisateur {name} pourra à nouveau se connecter.',
    search_placeholder: 'Rechercher des utilisateurs...',
    field_username: 'Identifiant',
    field_role: 'Rôle',
    field_phone: 'Téléphone',
    field_last_login: 'Dernière connexion',
    field_password: 'Mot de passe',
    field_password_confirm: 'Confirmer le mot de passe',
    password_mismatch: 'Les mots de passe ne correspondent pas',
    password_hint: 'Laissez vide pour conserver le mot de passe actuel',
    roles: {
      admin: 'Administrateur',
      tresorier: 'Trésorière',
      coordinateur: 'Coordinateur',
      secretaire: 'Secrétaire',
    },
    toast_created: 'Utilisateur {name} ajouté',
    toast_updated: 'Utilisateur {name} mis à jour',
    toast_deactivated: 'Utilisateur {name} désactivé',
    toast_activated: 'Utilisateur {name} réactivé',
  },
  modal: {
    unsaved_title: 'Modifications non enregistrées',
    unsaved_body: 'Vos modifications seront perdues. Continuer ?',
  },
  forbidden: {
    back_home: 'Retour au tableau de bord',
    need_permission: 'Permission requise : {permission}',
  },
  profile: {
    section_account: 'Informations du compte',
    section_security: 'Sécurité',
    change_password: 'Changer le mot de passe',
    current_password: 'Mot de passe actuel',
    new_password: 'Nouveau mot de passe',
    confirm_new_password: 'Confirmer le nouveau mot de passe',
    password_min: 'Minimum 8 caractères',
    password_mismatch: 'Les mots de passe ne correspondent pas',
    toast_password_changed: 'Mot de passe mis à jour',
    last_login: 'Dernière connexion',
    member_since: 'Membre depuis',
    api_mode_off: 'L’API n’est pas configurée — cette fonction nécessite le backend Spring Boot.',
  },
  roles_page: {
    new_role: 'Nouveau rôle',
    edit_role: 'Modifier le rôle',
    system_role: 'Rôle système',
    field_name: 'Nom du rôle',
    field_description: 'Description',
    field_permissions: 'Permissions',
    user_count: '{count} utilisateurs',
    delete_confirm_title: 'Supprimer ce rôle ?',
    delete_confirm_body: 'Le rôle {name} sera supprimé. Cette action est irréversible.',
    toast_created: 'Rôle {name} créé',
    toast_updated: 'Rôle {name} mis à jour',
    toast_deleted: 'Rôle supprimé',
    permissions_count: '{count} permissions',
    api_required: 'Cette page utilise les données réelles du backend. Configurez REACT_APP_API_URL pour activer.',
  },
  audit_page: {
    search_placeholder: 'Rechercher une action, un utilisateur...',
    field_when: 'Date',
    field_user: 'Utilisateur',
    field_action: 'Action',
    field_entity: 'Entité',
    field_description: 'Description',
    field_ip: 'IP',
    api_required: 'Cette page utilise les données réelles du backend. Configurez REACT_APP_API_URL pour activer.',
  },
  notifications: {
    title: 'Notifications',
    empty: 'Aucune activité récente',
    view_all: 'Voir tout',
  },
  toast: {
    success: 'Succès',
    error: 'Erreur',
    info: 'Information',
    warning: 'Attention',
    generic_error: 'Une erreur est survenue',
    not_implemented: 'Cette fonctionnalité arrive bientôt',
  },
  activity: {
    new_member: 'Nouveau membre inscrit : {name}',
    payment_confirmed: 'Paiement {ref} confirmé par le trésorier',
    event_updated: 'Pèlerinage {name} — capacité mise à jour',
    pilgrims_registered: '{count} nouveaux pèlerins inscrits pour {name}',
    report_exported: 'Rapport mensuel exporté par le trésorier',
  },
  time: {
    just_now: 'À l’instant',
    minutes_ago: 'Il y a {count} min',
    hours_ago: 'Il y a {count} h',
    yesterday: 'Hier',
    days_ago: 'Il y a {count} jours',
  },
  months: {
    short: {
      jan: 'janv.',
      feb: 'févr.',
      mar: 'mars',
      apr: 'avr.',
      may: 'mai',
      jun: 'juin',
      jul: 'juil.',
      aug: 'août',
      sep: 'sept.',
      oct: 'oct.',
      nov: 'nov.',
      dec: 'déc.',
    },
    abbr: {
      jan: 'JAN',
      feb: 'FÉV',
      mar: 'MAR',
      apr: 'AVR',
      may: 'MAI',
      jun: 'JUN',
      jul: 'JUL',
      aug: 'AOÛ',
      sep: 'SEP',
      oct: 'OCT',
      nov: 'NOV',
      dec: 'DÉC',
    },
  },
  reservations_page: {
    field_member: 'Membre de la communauté',
    member_yes: 'Membre',
    title: 'Réservations du site',
    subtitle: 'Réservations effectuées sur le site public',
    search_placeholder: 'Rechercher par code, nom, téléphone...',
    filter_status: 'Tous les statuts',
    filter_event: 'Tous les pèlerinages',
    view_title: 'Détails de la réservation',
    field_contact: 'Contact',
    field_payer: 'Numéro payeur',
    field_pilgrimage: 'Pèlerinage',
    field_people: 'Personnes',
    field_parish: 'Paroisse',
    field_emergency: 'Téléphone d’urgence',
    field_pickup: 'Point de départ',
    field_method: 'Moyen de paiement',
    field_customer_ref: 'Référence client',
    field_gateway_ref: 'Référence passerelle',
    field_gateway_tid: 'ID transaction passerelle',
    field_gateway_status: 'Statut passerelle',
    field_gateway_message: 'Message de la passerelle',
    field_linked_payment: 'Paiement lié',
    field_paid_at: 'Payé le',
    field_created_at: 'Créé le',
    section_contact: 'Personne de contact',
    section_participants: 'Voyageurs ({count})',
    section_payment: 'Paiement',
    amount_breakdown: '{people} × ({unit} + {fee} de frais)',
    statuses: {
      pending_payment: 'En attente de paiement',
      confirmed: 'Confirmée',
      failed: 'Échouée',
      cancelled: 'Annulée',
    },
    methods: {
      momo: 'Mobile Money',
      card: 'Carte',
    },
    stat_confirmed: 'Confirmées',
    stat_confirmed_caption: 'Réservations payées',
    stat_pending: 'En attente',
    stat_pending_caption: 'Validation MoMo en attente',
    stat_failed: 'Échouées',
    stat_failed_caption: '{count} annulée(s)',
    stat_collected: 'Encaissé',
    stat_collected_caption: 'RWF — paiements confirmés',
    stat_travellers: 'Voyageurs',
    stat_travellers_caption: 'Places confirmées',
    recheck: 'Revérifier le paiement',
    cancel_reservation: 'Annuler la réservation',
    cancel_confirm_title: 'Annuler cette réservation ?',
    cancel_confirm_body: 'La réservation {code} sera marquée comme annulée. Seules les réservations non payées peuvent être annulées.',
    toast_rechecked: '{code} : {status}',
    toast_cancelled: 'Réservation {code} annulée',
    gateway_missing_title: 'XentriPay n’est pas configuré sur le serveur',
    gateway_missing_body: 'Les paiements en ligne du site sont désactivés tant que la clé API XentriPay n’est pas définie comme secret du serveur.',
    empty_title: 'Aucune réservation',
    empty_body: 'Les réservations faites sur le site public apparaîtront ici.',
  },
  payouts_page: {
    collected: 'Encaissé',
    collected_caption: 'RWF — paiements en ligne confirmés',
    paid_out: 'Retiré',
    paid_out_caption: 'RWF — retraits envoyés',
    available: 'Disponible (estimation)',
    available_caption: 'XentriPay déduit ses frais de collecte',
    destination_title: 'Numéro de retrait',
    destination_subtitle: 'Le seul numéro pouvant recevoir les retraits',
    updated: 'modifié {when}',
    no_number_title: 'Aucun numéro de retrait configuré',
    no_number_body: 'Définissez le numéro Mobile Money qui recevra les retraits avant tout envoi de fonds.',
    change_number: 'Changer de numéro',
    set_number: 'Définir le numéro',
    admin_only: 'Seul l’administrateur (avec la permission payouts:manage) peut effectuer cette action.',
    mail_missing: 'L’e-mail (SMTP) n’est pas configuré : les codes de vérification ne peuvent pas être envoyés.',
    gateway_missing: 'XentriPay n’est pas configuré sur le serveur.',
    blocked_no_number: 'Définissez d’abord un numéro de retrait.',
    number_change_notice: 'Par sécurité, un code de vérification sera envoyé par e-mail à l’administrateur. Le nouveau numéro ne s’applique qu’après confirmation de ce code.',
    field_msisdn: 'Numéro Mobile Money',
    msisdn_hint: 'Format rwandais, ex. 2507XXXXXXXX',
    field_name: 'Nom du titulaire',
    name_hint: 'Tel qu’enregistré auprès de l’opérateur',
    field_provider: 'Opérateur',
    provider_auto: 'Détecter depuis le numéro',
    providers: {
      mtn: 'MTN Mobile Money',
      airtel: 'Airtel Money',
    },
    confirm_number_title: 'Confirmer le nouveau numéro',
    confirm_number: 'Confirmer le numéro',
    new_destination: 'Nouvelle destination',
    toast_number_updated: 'Numéro de retrait mis à jour',
    send_title: 'Envoyer des fonds',
    send_subtitle: 'Retirer l’argent encaissé',
    send_body: 'Transfère une partie du solde encaissé vers le numéro de retrait configuré. Chaque retrait doit être confirmé par un code envoyé par e-mail à l’administrateur.',
    new_payout: 'Nouveau retrait',
    new_payout_sub: 'Les fonds sont envoyés uniquement au numéro configuré',
    field_amount: 'Montant (RWF)',
    field_note: 'Note',
    field_recipient: 'Bénéficiaire',
    field_requested_by: 'Demandé par',
    amount_integer: 'Saisissez un montant entier en RWF',
    amount_min: 'Le retrait minimum est de {min}',
    amount_exceeds: 'Le montant dépasse le solde disponible ({available})',
    confirm_heading: 'Avant de continuer',
    confirm_only_number: 'L’argent sera envoyé UNIQUEMENT au {number} — il ne peut pas être redirigé vers un autre numéro.',
    confirm_email_code: 'Un code à 6 chiffres sera envoyé par e-mail à l’administrateur pour confirmer ce retrait.',
    confirm_xentripay_otp: 'XentriPay demandera ensuite au titulaire du compte d’approuver le transfert avec son propre code OTP avant de libérer les fonds.',
    confirm_estimate: 'Le solde disponible est une estimation : XentriPay déduit ses frais de collecte.',
    confirm_payout_title: 'Confirmer le retrait',
    send_payout: 'Envoyer le retrait',
    result_title: 'Retrait soumis',
    result_failed: 'La passerelle a refusé ce retrait',
    result_failed_generic: 'Aucun fonds n’a été envoyé. Vérifiez le statut de la passerelle et réessayez.',
    result_submitted: 'Retrait enregistré',
    result_approve_hint: 'Le titulaire du {number} doit maintenant approuver le transfert avec le code OTP XentriPay. Utilisez « Revérifier » pour actualiser son statut.',
    history_title: 'Historique des retraits',
    history_subtitle: 'Tous les retraits envoyés via XentriPay',
    history_empty: 'Aucun retrait pour l’instant',
    recheck: 'Revérifier',
    toast_rechecked: '{code} : {status}',
    statuses: {
      pending: 'En attente',
      completed: 'Terminé',
      successful: 'Réussi',
      failed: 'Échoué',
      reversed: 'Annulé (reversé)',
    },
  },
  otp: {
    title: 'Code de vérification',
    sent_to: 'Nous avons envoyé un code à 6 chiffres à {email}.',
    sent_generic: 'Nous avons envoyé un code à 6 chiffres à l’e-mail de l’administrateur.',
    code_label: 'Code de vérification',
    invalid_code: 'Saisissez le code à 6 chiffres',
    expires_in: 'Le code expire dans {time}',
    expired: 'Ce code a expiré — demandez-en un nouveau.',
    resend: 'Envoyer un nouveau code',
    resent: 'Un nouveau code a été envoyé',
    send_code: 'Envoyer le code de vérification',
  },
  monthly: {
    title: 'Pèlerinage mensuel',
    subtitle: 'Créé automatiquement pour le dernier dimanche de chaque mois',
    status_on: 'Automatique',
    status_off: 'En pause',
    rule_title: 'Fonctionnement des réservations',
    rule_body: 'Un pèlerinage est créé pour le dernier dimanche de chaque mois. Les réservations et paiements ferment le samedi précédent à {close}. Rouvrez les réservations depuis la liste des pèlerinages pour les garder ouvertes jusqu’au départ le dimanche à {departure}.',
    upcoming_booked: '{code} · {registered} réservés',
    field_places: 'Places',
    field_places_hint: 'Toute personne qui réserve pendant l’ouverture est acceptée',
    upcoming_pending: 'Sera créé automatiquement',
    booking_open: 'Réservations ouvertes',
    booking_closed: 'Réservations fermées',
    closes_at: 'Ferme le {when}',
    open_until: 'Rouvert jusqu’au {when}',
    field_enabled: 'Créer automatiquement le pèlerinage du dernier dimanche chaque mois',
    field_name: 'Nom du pèlerinage',
    field_name_hint: 'Le mois est ajouté automatiquement, ex. « … — November 2026 »',
    field_destination: 'Destination',
    field_price: 'Prix par personne',
    field_price_hint: 'Prix enregistré : {price}. Il reste en vigueur jusqu’à modification.',
    field_close_time: 'Fermeture des réservations (samedi)',
    field_close_time_hint: '00:00 = fermeture au début du samedi',
    field_departure_time: 'Départ (dimanche)',
    field_departure_time_hint: 'Les réservations rouvertes restent ouvertes jusque-là',
    field_months_ahead: 'Mois à l’avance',
    field_months_ahead_hint: 'Nombre de mois futurs ouverts (0–6)',
    field_description: 'Description',
    field_description_hint: 'Affichée sur la carte de réservation du site',
    price_invalid: 'Entrez un montant entier d’au moins 100 RWF',
    months_invalid: 'Entrez un nombre entre 0 et 6',
    time_invalid: 'Format HH:mm',
    toast_saved: 'Pèlerinage mensuel enregistré — pèlerinages à venir mis à jour',
    admin_only: 'Seul l’administrateur peut modifier ces paramètres.',
  },
  finance: {
    local_title: 'Aperçu — enregistré sur cet ordinateur',
    local_body: 'Les écritures sont conservées dans ce navigateur jusqu’à la connexion du registre financier au serveur. Exportez un CSV pour en garder une copie.',
    clear_samples: 'Supprimer les exemples',
    clear_samples_title: 'Supprimer les écritures d’exemple ?',
    clear_samples_body: 'Les transactions d’exemple ajoutées pour la démonstration seront supprimées. Vos propres écritures sont conservées.',
    period: 'Période',
    periods: { this_month: 'Ce mois', last_month: 'Mois dernier', this_year: 'Cette année', all: 'Tout', custom: 'Personnalisée' },
    period_range: '{from} – {to}',
    from: 'Du',
    to: 'Au',
    export_csv: 'Exporter CSV',
    print_report: 'Imprimer / PDF',
    total_income: 'Recettes',
    total_expense: 'Dépenses',
    net_balance: 'Solde',
    surplus: 'Excédent sur la période',
    deficit: 'Déficit sur la période',
    record_income: 'Enregistrer une recette',
    record_income_hint: 'Argent reçu — cotisations, offrandes, frais…',
    record_expense: 'Enregistrer une dépense',
    record_expense_hint: 'Argent dépensé — transport, fournitures, aide…',
    search_placeholder: 'Rechercher provenance, destination, référence…',
    all_types: 'Recettes et dépenses',
    all_categories: 'Toutes les catégories',
    ledger_title: 'Transactions',
    ledger_subtitle: '{count} écritures · {period}',
    empty_title: 'Aucune transaction sur cette période',
    empty_body: 'Enregistrez une recette ou une dépense pour commencer le registre.',
    new_entry: 'Nouvelle transaction',
    edit_entry: 'Modifier la transaction',
    form_subtitle: 'D’où vient l’argent et où il est allé',
    record: 'Enregistrer',
    amount_invalid: 'Saisissez un montant supérieur à 0',
    field_type: 'Type',
    field_date: 'Date',
    field_amount: 'Montant',
    field_category: 'Catégorie',
    field_method: 'Moyen de paiement',
    field_source_income: 'Reçu de',
    field_source_expense: 'Payé depuis',
    field_destination_income: 'Déposé sur',
    field_destination_expense: 'Payé à',
    hint_source_income: 'Qui a donné l’argent, ex. membres, bienfaiteur',
    hint_source_expense: 'Quel compte ou quelle caisse a payé',
    hint_destination_income: 'Où il est conservé, ex. caisse, MoMo, banque',
    hint_destination_expense: 'Qui l’a reçu, ex. fournisseur, famille',
    field_reference: 'Référence',
    hint_reference: 'Numéro de reçu, de facture ou de transaction',
    field_description: 'Description',
    col_code: 'N°',
    col_flow: 'De → À',
    col_from: 'De',
    col_to: 'À',
    col_recorded_by: 'Enregistré par',
    breakdown_income: 'Recettes par catégorie',
    breakdown_expense: 'Dépenses par catégorie',
    breakdown_empty: 'Rien d’enregistré sur cette période.',
    report_title: 'Rapport financier',
    report_generated: 'Généré le {date} par {name}',
    report_transactions: 'Transactions',
    delete_title: 'Supprimer cette transaction ?',
    delete_body: 'La transaction {code} sera retirée du registre.',
    toast_income: 'Recette enregistrée',
    toast_expense: 'Dépense enregistrée',
    toast_updated: 'Transaction mise à jour',
    toast_deleted: 'Transaction supprimée',
    toast_samples_cleared: 'Exemples supprimés',
    toast_exported: '{count} transactions exportées',
    types: { income: 'Recette', expense: 'Dépense' },
    methods: { cash: 'Espèces', mobile_money: 'Mobile Money', bank_transfer: 'Virement bancaire', card: 'Carte', cheque: 'Chèque' },
    categories: {
      contributions: 'Cotisations des membres',
      offerings: 'Offrandes et dons',
      pilgrimage_fees: 'Frais de pèlerinage',
      fundraising: 'Collecte de fonds',
      grants: 'Subventions et appuis',
      other_income: 'Autres recettes',
      transport: 'Transport',
      accommodation: 'Hébergement',
      food: 'Restauration',
      liturgy: 'Liturgie et fournitures d’église',
      communication: 'Impression et communication',
      charity: 'Charité et entraide',
      allowances: 'Indemnités',
      fees: 'Frais bancaires et MoMo',
      equipment: 'Équipement',
      other_expense: 'Autres dépenses',
    },
  },
  settings_page: {
    integrations_title: 'État des intégrations',
    integrations_subtitle: 'Passerelle de paiement, webhook & e-mail',
    integration_gateway: 'Clé API XentriPay',
    integration_gateway_hint: 'Nécessaire pour encaisser les paiements du site et envoyer les retraits',
    integration_webhook: 'Secret du webhook XentriPay',
    integration_webhook_hint: 'Permet à la passerelle de confirmer automatiquement les paiements',
    integration_mail: 'E-mail SMTP',
    integration_mail_hint: 'Envoie les codes de vérification et les confirmations',
    configured: 'Configuré',
    missing: 'Manquant',
    fee_title: 'Frais de réservation',
    fee_subtitle: 'Frais de transaction ajoutés par voyageur',
    fee_label: 'Frais par personne',
    fee_hint: 'Ajoutés pour chaque voyageur lors des réservations en ligne (0 – 100 000 RWF)',
    fee_invalid: 'Saisissez un montant entier entre 0 et 100 000',
    toast_fee_saved: 'Frais de réservation fixés à {fee}',
  },
  transport_page: {
    tab_buses: 'Bus',
    tab_locations: 'Points de départ',
    tab_assignments: 'Affectations',
    buses_title: 'Flotte',
    buses_subtitle: 'Bus et chauffeurs enregistrés',
    buses_empty: 'Aucun bus enregistré',
    locations_title: 'Points de départ',
    locations_subtitle: 'Lieux de prise en charge proposés aux voyageurs',
    locations_empty: 'Aucun point de départ',
    search_buses: 'Rechercher plaque, chauffeur...',
    search_locations: 'Rechercher un lieu...',
    new_bus: 'Nouveau bus',
    edit_bus: 'Modifier le bus',
    new_location: 'Nouveau lieu',
    edit_location: 'Modifier le lieu',
    field_plate: 'Plaque',
    field_bus_name: 'Nom',
    bus_name_hint: 'Optionnel — ex. « Coaster 1 »',
    field_capacity: 'Places',
    field_driver: 'Chauffeur',
    field_driver_phone: 'Téléphone du chauffeur',
    field_location_name: 'Lieu',
    field_address: 'Adresse',
    field_departure_time: 'Heure de départ',
    departure_time_hint: 'Heure de départ habituelle (HH:mm)',
    field_bus: 'Bus',
    field_location: 'Point de départ',
    capacity_invalid: 'Entre 1 et 150 places',
    active: 'Actif',
    inactive: 'Inactif',
    active_bus: 'Bus disponible pour les affectations',
    active_location: 'Proposé aux voyageurs sur le site',
    seats_count: '{count} places',
    bus: 'Bus',
    no_driver: 'Aucun chauffeur indiqué',
    pick_event: 'Choisissez un pèlerinage',
    assign_bus: 'Affecter un bus',
    assign: 'Affecter',
    unassign: 'Retirer',
    unassign_title: 'Retirer ce bus ?',
    total_seats: 'Places',
    total_travellers: 'Voyageurs confirmés',
    buses_assigned: 'Bus',
    travellers_hint: 'Les voyageurs sont comptés à partir des réservations confirmées sur le site, par point de départ.',
    group_subtitle: '{buses} bus affecté(s)',
    capacity_line: '{passengers} voyageurs / {seats} places',
    seats_missing: 'Il manque {count} places',
    seats_ok: '{count} places libres',
    assignments_empty: 'Aucun bus affecté pour l’instant',
    assignments_empty_body: 'Affectez des bus aux points de départ de {name}.',
    no_free_bus: 'Tous les bus actifs sont déjà affectés à ce pèlerinage.',
    no_active_location: 'Ajoutez d’abord un point de départ actif.',
    already_assigned: 'Ce bus est déjà affecté à ce pèlerinage.',
    toast_bus_saved: 'Bus {plate} enregistré',
    toast_location_saved: 'Lieu {name} enregistré',
    toast_assigned: 'Bus affecté',
    toast_deleted: 'Supprimé',
    delete_title: 'Supprimer ?',
    delete_bus_body: 'Le bus {plate} sera supprimé.',
    delete_location_body: 'Le lieu {name} sera supprimé.',
    delete_assignment_body: 'Le bus {plate} sera retiré de ce pèlerinage.',
  },
  documents_page: {
    title: 'Procès-verbaux & rapports',
    subtitle: 'Archives de la paroisse',
    search_placeholder: 'Rechercher titre, contenu...',
    filter_category: 'Toutes les catégories',
    new_document: 'Nouveau document',
    edit_document: 'Modifier le document',
    field_title: 'Titre',
    field_category: 'Catégorie',
    field_meeting_date: 'Date de la réunion',
    field_location: 'Lieu',
    field_attendees: 'Participants',
    field_author: 'Auteur',
    field_content: 'Contenu',
    attendees_hint: 'Optionnel — noms séparés par des virgules',
    content_placeholder: 'Rédigez ici le procès-verbal ou le rapport...',
    content_required: 'Le document ne peut pas être vide',
    no_content: 'Aucun contenu',
    updated_on: 'Modifié le {date}',
    print: 'Imprimer / Enregistrer en PDF',
    categories: {
      minutes: 'Procès-verbal',
      report: 'Rapport',
      announcement: 'Annonce',
      other: 'Autre',
    },
    toast_created: '« {title} » créé',
    toast_updated: '« {title} » enregistré',
    toast_deleted: 'Document supprimé',
    delete_confirm_title: 'Supprimer ce document ?',
    delete_confirm_body: '« {title} » sera définitivement supprimé.',
    empty_title: 'Aucun document pour l’instant',
    empty_body: 'Consignez ici les procès-verbaux, rapports et annonces.',
  },
  editor: {
    toolbar: 'Mise en forme',
    bold: 'Gras',
    italic: 'Italique',
    underline: 'Souligné',
    strike: 'Barré',
    heading: 'Titre {level}',
    bullet_list: 'Liste à puces',
    ordered_list: 'Liste numérotée',
    blockquote: 'Citation',
    horizontal_rule: 'Séparateur',
    link: 'Lien',
    remove_link: 'Supprimer le lien',
    undo: 'Annuler',
    redo: 'Rétablir',
  },
  validation: {
    required: 'Ce champ est requis',
    invalid_email: 'Email invalide',
    invalid_phone: 'Numéro de téléphone invalide',
    min_length: 'Minimum {count} caractères',
    number_required: 'Doit être un nombre',
  },
};

export default fr;
